
    import Vue from "vue";
    import {mapState} from "vuex";

    export default Vue.extend({
    name: "RomaPercentage",
    props: {
        unit: {
            type: Object,
            required: true
        }
    },
    methods: {
        percentage(number: number): number {
            return number >= 0 && number !== null ? number : 0;
        },
    },
    computed: {
        percentageObject() {
            if (this.unit.plan_status_id === 1 || this.unit.plan_status_id === 3) {
                return {
                    circularPercentageTittle: this.$vuetify.lang.t('$vuetify.component.romaPercentage.percentageAdvancerOas'),
                    curricularPercentageTittle: this.$vuetify.lang.t('$vuetify.component.romaPercentage.percentageAdvancerCurricular'),
                    circularPercentage: this.unit.itemsDonePercentage,
                    curricularPercentage: this.unit.doneCurricularPercentage,
                };
            } else {
                return {
                    circularPercentageTittle: this.$vuetify.lang.t('$vuetify.component.romaPercentage.percentageOasPlanificados'),
                    curricularPercentageTittle: this.$vuetify.lang.t('$vuetify.component.romaPercentage.percentageCurricular'),
                    circularPercentage: this.unit.itemsPlannedPercentage,
                    curricularPercentage: this.unit.plannedCurricularPercentage,
                };
            }
        },
        ...mapState([
            'user',
        ]),
    },
});
